export default __webpack_public_path__ + "7bfd213f3a418ac151bc0b999684c22a.png";